import React from "react";
import { Reveal, Overline } from "./Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3OTAxMjQ3Mnww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="section-y relative">
      <div className="max-page container-px grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <Reveal className="lg:col-span-5 lg:sticky lg:top-32">
          <Overline>About</Overline>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-foreground">
            One trusted partner across <em className="text-primary not-italic">many industries.</em>
          </h2>
          <p className="mt-8 text-base sm:text-lg text-muted-foreground leading-relaxed max-w-md">
            One Sphere is a multidisciplinary trading house — built to consolidate
            sourcing, supply and service into a single, accountable relationship.
            We work behind the scenes for developers, contractors, retailers,
            studios and enterprises who refuse to compromise.
          </p>
          <div className="mt-10 flex items-center gap-6">
            <div className="font-display text-5xl text-primary">∞</div>
            <p className="text-sm text-muted-foreground max-w-xs">
              From a single SKU to full-project procurement —
              one calm, considered point of contact.
            </p>
          </div>
        </Reveal>

        <div className="lg:col-span-7 space-y-6">
          <Reveal delay={0.1}>
            <div className="relative overflow-hidden rounded-2xl border border-border group">
              <div className="aspect-[5/4]">
                <img
                  src={ABOUT_IMG}
                  alt="Minimal modern architecture"
                  className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
                />
              </div>
              <div className="absolute bottom-0 inset-x-0 p-6 bg-gradient-to-t from-foreground/40 to-transparent text-background">
                <span className="overline text-background/90" style={{ color: "rgba(255,255,255,0.9)" }}>
                  A studio of operators
                </span>
              </div>
            </div>
          </Reveal>

          <div className="grid sm:grid-cols-2 gap-6">
            {[
              {
                t: "Built for trust",
                d: "Every quotation is itemised, traceable and backed by certified vendor relationships across the GCC and beyond.",
              },
              {
                t: "Built for scale",
                d: "From a boutique villa fit-out to enterprise HVAC contracts — the same diligence, scaled to the brief.",
              },
              {
                t: "Built for clarity",
                d: "One coordinator. One timeline. One invoice envelope. No fragmented vendor chaos.",
              },
              {
                t: "Built for excellence",
                d: "We curate what we supply — every category has a hand-picked, vetted catalogue.",
              },
            ].map((c, i) => (
              <Reveal key={c.t} delay={0.05 * i}>
                <div
                  data-testid={`about-pillar-${i}`}
                  className="h-full p-7 rounded-2xl border border-border bg-card hover:-translate-y-1 hover:shadow-[0_18px_50px_-20px_rgba(43,58,66,0.18)] transition-all duration-500"
                >
                  <div className="font-display text-2xl text-foreground">{c.t}</div>
                  <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{c.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
